import { render, staticRenderFns } from "./TermsWordCloudChart.vue?vue&type=template&id=66c4aea4&"
import script from "./TermsWordCloudChart.vue?vue&type=script&lang=js&"
export * from "./TermsWordCloudChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports